import { render, staticRenderFns } from "./InstallmentProductConfigModal.vue?vue&type=template&id=65cb8704"
import script from "./InstallmentProductConfigModal.vue?vue&type=script&lang=js"
export * from "./InstallmentProductConfigModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports